import React from "react";

import { IAppointmentActionResponse } from "modules/appointment/types/IAppointmentActionResponse";
import { IEReservationIntervalElement } from "modules/appointment/types/IEReservationIntervalElement";

import { ChakraText } from "components/ChakraText";
import { Button, CustomColorScheme, IButtonProps } from "components/Button";
import { useModal } from "components/Modal";

import { EditAppointmentConfirmationModal } from "./EditAppointmentConfirmationModal";

interface IProps extends Pick<IButtonProps, "disabled"> {
  intervalElement: IEReservationIntervalElement | null;
  tokenId: string;
  appointment: IAppointmentActionResponse;
}

const EditAppointment = ({ intervalElement, tokenId, appointment }: IProps) => {
  const { isOpen, onOpen, onClose } = useModal();
  return (
    <>
      {intervalElement && (
        <EditAppointmentConfirmationModal
          tokenId={tokenId}
          isOpen={isOpen}
          onClose={onClose}
          appointment={appointment}
          intervalElement={intervalElement}
        />
      )}
      <Button
        customColorScheme={CustomColorScheme.Green}
        disabled={!intervalElement}
        h="80px"
        w="300px"
        onClick={onOpen}
        id="confirm-edit-appointment-btn"
      >
        <ChakraText>Potwierdź zmianę terminu</ChakraText>
      </Button>
    </>
  );
};

export { EditAppointment };
